// src/polyfills.js
if (typeof process === 'undefined') {
    window.process = { env: {}, browser: true }
}
if (typeof global === 'undefined') {
    window.global = window;
}